import { useContext } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TechsContexts } from "../../contexts/TechsContext";
import { UserContext } from "../../contexts/UserContext";
import Form from "../Form/index";
import { FormButton, EventButton } from "../Button";
import { AiOutlineClose } from "react-icons/ai";
import { ModalContainer, StyledModal } from "./styles";

interface ITechs {
  title: string;
  status: string;
}

export const AddModal = () => {
  const { newTech, setShowAddModal } = useContext(TechsContexts);

  const schema = yup.object({
    title: yup.string().required("Nome obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ITechs>({
    resolver: yupResolver(schema),
  });

  return (
    <ModalContainer>
      <StyledModal>
        <header>
          <h3>Cadastrar Tecnologia</h3>
          <button
            className="iconButton"
            type="button"
            onClick={() => setShowAddModal(false)}
          >
            <AiOutlineClose />
          </button>
        </header>
        <Form onSubmit={handleSubmit(newTech)}>
          <label htmlFor="title">Nome</label>
          <div className="inputContent">
            <input type="text" id="title" {...register("title")} />
            <p>{errors.title?.message}</p>
          </div>
          <label htmlFor="status">Selecionar status</label>
          <div className="inputContent">
            <select id="status" {...register("status")}>
              <option value="Iniciante">Iniciante</option>
              <option value="Intermediário">Intermediário</option>
              <option value="Avançado">Avançado</option>
            </select>
          </div>
          <FormButton
            buttonSize={"default"}
            buttonStyle={"primary"}
            type="submit"
            link=""
          >
            Cadastrar Tecnologia
          </FormButton>
        </Form>
      </StyledModal>
    </ModalContainer>
  );
};

export const LogoutModal = () => {
  const { setShowModalLogout, handleLogout } = useContext(UserContext);

  return (
    <ModalContainer>
      <StyledModal>
        <header>
          <h3>Tem certeza que deseja sair?</h3>
          <button
            className="iconButton"
            type="button"
            onClick={() => setShowModalLogout(false)}
          >
            <AiOutlineClose />
          </button>
        </header>
        <section>
          <EventButton
            buttonSize={"default"}
            buttonStyle={"primary"}
            onClick={handleLogout}
            link=""
          >
            Sair
          </EventButton>
          <EventButton
            buttonSize={"default"}
            buttonStyle={"primary-disable"}
            onClick={() => setShowModalLogout(false)}
            link=""
          >
            Cancelar
          </EventButton>
        </section>
      </StyledModal>
    </ModalContainer>
  );
};
